import React from "react";
import EmailValidator from "email-validator";
import "./EmailInput.scss";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import classNames from 'classnames';
import { setEmail, sendError } from "../../common/redux/actions";
import { Status } from "../../common/const/const";
import routes from "../../common/routes/routes";

const EMAIL_NOT_VALID = {
    errorCode: "AuthorizationRequiredError",
    errorMessage: "Недопустимое имя почты"
}

const EmailInput = ({ switchStatus, authService }) => {
    const [emailValue, setEmailValue] = React.useState("");
    const [validEmail, setValidEmail] = React.useState(true);
    const dispatch = useDispatch();
    const history = useHistory();

    const onChangeEmail = React.useCallback(event => {
        event.preventDefault();
        const {value} = event.currentTarget;
        setEmailValue(value);
    }, []);

    const onSendEmail = React.useCallback(
        async (event) => {
            event.preventDefault();
            if (EmailValidator.validate(emailValue)) {
                setValidEmail(true);

                await authService.getCode(emailValue).then(() => {
                    dispatch(setEmail(emailValue));
                    switchStatus(Status.VERIFICATION);
                    history.push(routes.VERIFY);
                }).catch(error => {
                    dispatch(sendError(error))
                })
            } else {
                setValidEmail(false);
                dispatch(sendError(EMAIL_NOT_VALID))
            }
        },
        [emailValue, authService, dispatch, switchStatus, history]
    );
    return (
        <form className="Entrance__form" name="entrance" onSubmit={onSendEmail}>
            <label className="Entrance__label" htmlFor="email">
                <input
                    value={emailValue}
                    onChange={onChangeEmail}
                    className={classNames('Entrance__input', {
                        'Entrance__input_error': !validEmail
                    })}
                    id="email"
                    name="email"
                    type="email"
                    placeholder="Введите Ваш email"
                />
            </label>
            <button className="Entrance__btn" type="submit">
        Отправить
            </button>
        </form>
    );
};

export default EmailInput ;
